export default __webpack_public_path__ + "static/media/delivery.35e88a94.jpg";